import { render } from "./RevenueSummary.vue?vue&type=template&id=737ef010&scoped=true"
import script from "./RevenueSummary.vue?vue&type=script&lang=js"
export * from "./RevenueSummary.vue?vue&type=script&lang=js"

import "./RevenueSummary.vue?vue&type=style&index=0&id=737ef010&scoped=true&lang=css"

import exportComponent from "/Users/palla/Development/improvers/kon-platform-wallboards-frontend/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.39_vue@3.5.39_typescript@7.0.2__webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-737ef010"]])

export default __exports__